import { useState } from "react";
import { da } from "date-fns/locale";
import { CalendarIcon, Lock } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { daDate, toDate, toISO, isClosedDate } from "@/lib/date";

export function DanishDatePicker({ value, onChange, testid, allowClosed = false }) {
  const [open, setOpen] = useState(false);
  const selected = value ? toDate(value) : undefined;
  const disabled = allowClosed ? undefined : isClosedDate;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testid}
          className="h-10 rounded-xl w-full justify-start font-normal bg-white text-stone-800">
          <CalendarIcon className="h-4 w-4 mr-2 text-stone-400" strokeWidth={1.75} />
          {value ? daDate(value) : <span className="text-stone-400">Vælg dato</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-2xl" align="start">
        <Calendar mode="single" locale={da} selected={selected} defaultMonth={selected}
          disabled={disabled}
          modifiers={allowClosed ? undefined : { closed: isClosedDate }}
          modifiersClassNames={{ closed: "line-through text-stone-300" }}
          onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }} />
        {!allowClosed && (
          <div className="flex items-start gap-2 px-4 py-3 border-t border-[#EBE8E3] text-xs text-stone-500" data-testid="datepicker-closed-note">
            <Lock className="h-3.5 w-3.5 text-[#A83232] mt-0.5 shrink-0" strokeWidth={2} />
            <span><span className="font-semibold text-[#A83232]">BSM har lukket</span> i uge 29-31 og 20. dec – 3. jan. Disse dage kan ikke vælges.</span>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
